import { atom, selector } from 'recoil'
import moment from 'moment-timezone'
import { zones } from 'mailup-react-helpers'

export const INPUT_MINUTES_STEP = 5

export const TYPE_H = 'hours'
export const TYPE_M = 'minutes'
export const TYPE_D = 'date'

export const MIN_H = 0
export const MIN_M = 0

export const MAX_H = 23
export const MAX_M = 55

export const roundToClosestMultiple = (value, n = 1) => Math.ceil(value / n) * n

export const contentScheduledState = atom({
  key: 'contentScheduledState',
  default: {
    validHour: true,
    validMinutes: true,
    validDate: true,
    boxError: false,
    showFeedback: false,
    timeZone: '',
    momentTimeZoneDate: moment.utc(new Date().toISOString()),
    momentUtcDate: moment.utc(new Date().toISOString()),
    isDirty: false
  }
})

export const setBoxErrorState = selector({
  key: 'contentScheduledStatesetBoxErrorState',
  set: ({ set }, boxError) => {
    set(contentScheduledState, prev => ({
      ...prev,
      boxError
    }))
  },
  get: ({ get }) => {
    return get(contentScheduledState)
  }
})

export const isValidDateState = selector({
  key: 'contentScheduledStatesetIsValidDateState',
  get: ({ get }, boxError) => {
    const { validHour, validMinutes, validDate } = get(contentScheduledState)
    return validHour && validMinutes && validDate
  }
})

export const setUtcDate = selector({
  key: 'contentScheduledStatesetUtcDateState',
  set: ({ set, get }, utcDate) => {
    const { timeZone } = get(contentScheduledState)
    const momentUtcDate = moment(utcDate).utc()
    const momentTimeZoneDate = moment.tz(momentUtcDate, zones[timeZone])
    set(contentScheduledState, prev => ({
      ...prev,
      momentTimeZoneDate,
      momentUtcDate
    }))
  },
  get: ({ get }) => {
    return get(contentScheduledState)
  }
})

export const setTzDate = selector({
  key: 'contentScheduledStatesetTzDate',
  set: ({ set, get }, tzDateDate) => {
    const { timeZone } = get(contentScheduledState)
    const momentUtcDate = moment(tzDateDate.replace('Z', '')).utc()
    const momentTimeZoneDate = moment.tz(momentUtcDate, zones[timeZone])
    set(contentScheduledState, prev => ({
      ...prev,
      momentTimeZoneDate,
      momentUtcDate
    }))
  },
  get: ({ get }) => {
    return get(contentScheduledState)
  }
})

export const setTimeZone = selector({
  key: 'contentScheduledStatesetTimeZone',
  set: ({ set, get }, timeZone) => {
    const { momentUtcDate } = get(contentScheduledState)
    const newTimeZoneDate = moment.utc(momentUtcDate).tz(zones[timeZone])
    const newUtcDate = moment.utc(newTimeZoneDate)
    set(contentScheduledState, prev => ({
      ...prev,
      timeZone,
      momentTimeZoneDate: newTimeZoneDate,
      momentUtcDate: newUtcDate
    }))
  },
  get: ({ get }) => {
    return get(contentScheduledState)
  }
})

export const setDateContentIsDirty = selector({
  key: 'contentScheduledStateSetDateContentIsDirty',
  set: ({ set }, isDirty) => {
    set(contentScheduledState, prev => ({
      ...prev,
      isDirty
    }))
  },
  get: ({ get }) => {
    return get(contentScheduledState)
  }
})

export const getDateContentIsDirty = selector({
  key: 'contentScheduledStatesetGetDateContentIsDirty',
  get: ({ get }, boxError) => {
    const { isDirty } = get(contentScheduledState)
    return isDirty
  }
})
